export const GoogleMapApiConfig = 'AIzaSyBSrh7VXEQTXqoZyNS8kjh6ANCRdKHklOQ';